import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
    UploadButton,
    InputButtonContainer
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { SelectInput } from "../../../components/select/select";
import { useState } from "react";

//Registration schema
const schema = yup.object().shape({
    name: yup.string().required("Name is a required field"),
    email: yup.string().email().required("Email is a required field"),
    phoneNumber: yup.string().required("Phone Number is a required field"),
    school: yup.string().required("School is a required field"),
    class: yup.string().required("Class is a required field"),
    registrationId: yup.string().required("Registration ID is a required field"),
    parentName: yup.string().required("Parent Name is a required field"),
    parentNumber: yup.string().required("Parent Number is a required field"),
});

const AdminAddStudent = () => {
    const [imageUploadValue, setImageUploadValue] = useState('')

    const handleImageUploadValue = (e) => {
        const file = e.target.files[0]
        setImageUploadValue(file.name)
    }
    const subjectOptions = [
        {
            value: "english",
            label: "English Language",
        },
        {
            value: "mathematics",
            label: "Mathematics",
        },
    ];
    const classOptions = [
        {
            value: "jss1",
            label: "JSS 1",
        },
        {
            value: "jss2",
            label: "JSS 2",
        },
    ];

    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
        // watch,
    } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

    const onSubmit = values => {
        console.log(values)
    }

    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container >
                    <MainContent>
                        <Heading>
                            Students
                        </Heading>
                        <Breadcrumb
                            crumbs={['Students', "add"]}
                        />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <InputWrapper>
                                <Input
                                    id="studentName"
                                    label="Name"
                                    type="text"
                                    {...register("name")}
                                    error={errors.name?.message}
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper className="grid-2-2">
                                <Input
                                    id="instructorEmail"
                                    label="Email"
                                    type="text"
                                    {...register("email")}
                                    error={errors.email?.message}
                                    fullWidth
                                />
                                <Input
                                    id="instructorPhone"
                                    label="Phone number"
                                    type="text"
                                    {...register("phoneNumber")}
                                    error={errors.phoneNumber?.message}
                                    fullWidth
                                />

                            </InputWrapper>

                            <InputWrapper className="grid-2-2">
                                <Controller
                                    control={control}
                                    name="school"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="school"
                                                type="text"
                                                label="SCHOOL"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.school?.message}
                                                options={classOptions}
                                            />
                                        </>
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="class"
                                    render={({ field: { onChange } }) => (
                                        <>
                                            <SelectInput
                                                id="class"
                                                type="text"
                                                label="class"
                                                onChange={(val) => onChange(val.value)}
                                                error={errors.class?.message}
                                                options={classOptions}
                                            />
                                        </>
                                    )}
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Input
                                    id="registrationId"
                                    label="REGISTRATION ID"
                                    type="text"
                                    {...register("registrationId")}
                                    error={errors.registrationId?.message}
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper className="grid-2-2">
                                <Input
                                    id="PARENT/GUARDIAN'SNAME"
                                    label="PARENT/GUARDIAN'S NAME"
                                    type="text"
                                    {...register("parentName")}
                                    error={errors.parentName?.message}
                                    fullWidth
                                />
                                <Input
                                    id="PARENT/GUARDIAN'SNUMBER"
                                    label="PARENT/GUARDIAN'S NUMBER"
                                    type="text"
                                    {...register("parentNumber")}
                                    error={errors.parentNumber?.message}
                                    fullWidth
                                />

                            </InputWrapper>

                            <InputWrapper>
                                <InputButtonContainer>
                                    <Input value={imageUploadValue} type='text' placeholder="Upload Image" fullWidth />
                                    <label htmlFor="contained-button-file">
                                        <input onChange={handleImageUploadValue} accept="image/*" id="contained-button-file" multiple type="file" style={{ display: 'none' }} />
                                        <UploadButton variant="contained" component="span"
                                            disableElevation
                                            color="primary"
                                        >
                                            BROWSE
                                        </UploadButton>
                                    </label>
                                </InputButtonContainer>
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto', marginTop: '6rem' }}
                                responsive
                            >
                                ADD
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper >
    )
}

export default AdminAddStudent
